import { useEffect, useMemo, useState } from 'react';

export function useDebounce<T>(value: T, delay = 1000): T {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	useEffect(() => {
		const timer = setTimeout(() => setDebouncedValue(value), delay);
		return () => {
			clearTimeout(timer);
		};
	}, [value, delay]);

	return useMemo(() => debouncedValue, [debouncedValue]);
}
